<template>
    <div class="container">
        <!--<div class="telphone">-->
            <!--<i class="el-icon-phone-outline icon"></i>-->
            <!--<span class="telfont">咨询电话：400-818-0005</span>-->
        <!--</div>-->
        <div class="nav">
            <img class="logo" src="../assets/logo.png">
            <Menu mode="horizontal" @on-select="handleSelect" class="nav1" active-key="1">
                <MenuItem key="1" name="index">首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页</MenuItem>
                <MenuItem key="2" name="company">公司介绍</MenuItem>
                <MenuItem key="3" name="product">产品频道</MenuItem>
                <Submenu key="4" name="online" >
                    <template slot="title">产品演示</template>
                    <MenuItem :name="item.url" v-for="item in links" v-bind:key="item.url">{{item.title}}</MenuItem>
                    <!-- <MenuItem name="bl">病例分析</MenuItem> -->
                </Submenu>
                <Submenu key="5" name="media">
                    <template slot="title">媒体频道</template>
                    <MenuItem name="zx">最新发布</MenuItem>
                    <MenuItem name="bl">病例分析</MenuItem>
                </Submenu>
            </Menu>
            <Button @click="value1 = true" type="primary" class="nav2" icon="md-menu" ghost></Button>
            <Drawer title="爱医博通" placement="left" :closable="false" v-model="value1">
                <CellGroup>
                    <Cell title="首页" to="/index"/>
                    <Cell title="公司介绍" to="/company"/>
                    <Cell title="产品频道" to="/product"/>
                    <Cell title="最新发布" to="/zx"/>
                    <Cell title="病例分享" to="/bl"/>
                </CellGroup>
            </Drawer>
        </div>
    </div>
</template>
<script>
// import {links} from '../../dist/web.js'
// import {links} from '../../web.js'
export default {
    data(){
        return {
            value1: false,
            links:[]
        }
    },
    created(){
        // console.log(window.links);
        this.links = window.links
    },
    methods: {
        handleSelect(name){
            if(name != 'index' && name != 'company' && name != 'product' && name != 'zx' && name != 'bl' && name != 'online' && name != 'media'){
                window.open(name).location
            }else{
                this.$router.push(name)
            }
        }
    }
}
</script>
<style>
.ivu-menu-light .ivu-menu-item-active, .ivu-menu-item:hover{
    color:#1858c2;
    border-bottom: 2px solid #1858c2;
}

.ivu-menu-horizontal.ivu-menu-light:after{
    height:0
}
</style>
<style scoped>
.container{
    display: flex;
    flex-direction: column;
    color: #606266;
    margin:0.2rem 0 0 0;
}
.nav{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.telphone{
    align-items: center;
}
.icon{
    font-size: 0.18rem
}
.telfont{
    font-size: 0.18rem
}
.logo{
    width:160px;
    height:42px;
}
@media (max-width: 768px) {
    /*超小屏幕设备 手机*/
    .container{
        padding:0 0.4rem;
        margin:0 auto;
    }
    .nav1{
        display: none;
    }
    .logo{
        margin-top:0.3rem;
    }
}

@media (min-width: 768px) and (max-width: 992px) {
    /*小屏幕设备 平板*/
    .container{
        padding:0 0.4rem;
        margin:0.2rem  auto 0 auto;
    }
    .news-imgs{
        width:22%;
        margin-bottom:0.2rem;
    }
    .nav2{
        display: none
    }
}

@media (min-width: 992px) and (max-width: 1200px) {
    /*中等屏幕设备 桌面*/
    .container{
        max-width:1200px;
        padding:0 0.8rem;
        margin:0.2rem  auto 0 auto;
    }
    .news-imgs{
        width:23%;
        margin-bottom:0.2rem;
    }
    .nav2{
        display: none
    }
}

@media (min-width: 1200px) {
    /*大屏幕设备 桌面*/
    .container{
        max-width:1200px;
        padding:0 0.8rem;
        margin:0.2rem  auto 0 auto;
    }
    .news-imgs{
        width:23%;
        margin-bottom:0.2rem;
    }
    .nav2{
        display: none
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue